export default __webpack_public_path__ + "static/media/messengerIconWhiteBackground3x.bdb95d82.png";